import React from 'react';

import { Component } from "react";
import SolicitacaoHistoricoRegistro from '../../component/SolicitacaoAtividade/SolicitacaoHistoricoRegistro/SolicitacaoHistoricoRegistro';
import { H3 } from 'view/component/Tipografia/Texto';
import styled from 'styled-components';

export default class SolicitacaoHistoricoSecao extends Component {
  render() {
    return (
      <Section>
        <H3 srOnly>Histórico</H3>

        <SolicitacaoHistoricoRegistro />
        <SolicitacaoHistoricoRegistro />
        <SolicitacaoHistoricoRegistro />
        <SolicitacaoHistoricoRegistro />
        <SolicitacaoHistoricoRegistro />
        <SolicitacaoHistoricoRegistro />
        <SolicitacaoHistoricoRegistro />
        
      </Section>
    )
  }
}

const Section = styled.section`
  width: 100%;
`;